import theme from "./main.json";
// import theme from "./qualigence.json";
export default theme